import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';

import {
  AutoquoteError,
  AutoquoteRequest,
  AutoquoteTiersResponseState,
  fetchAutoquoteTiers,
  newAutoquoteLoading,
} from 'portal/lib/autoquote';

const AUTOQUOTE_DEBOUNCE_MS = 400;

/**
 * Returns the state of the most recently requested autoquotes as a list based on lead times and a function
 * that can be called to request a new autoquote.
 */
const useRequestAutoquoteTiers = (initRequest: AutoquoteRequest) => {
  const [autoquoteTiersResponseState, setAutoquoteResponseState] =
    useState<AutoquoteTiersResponseState>(newAutoquoteLoading());

  useEffect(() => {
    fetchAutoquoteRequest(initRequest);
    /* eslint-disable-next-line */
  }, []);

  const fetchAutoquoteRequest = (request: AutoquoteRequest) => {
    setAutoquoteResponseState(newAutoquoteLoading());

    fetchAutoquoteTiers(request)
      .then(res => {
        setAutoquoteResponseState(res);
      })
      .catch((error: AutoquoteError) => {
        setAutoquoteResponseState(error);
      });
  };

  const fetchAutoquoteTiersDebounced = useCallback(
    debounce(fetchAutoquoteRequest, AUTOQUOTE_DEBOUNCE_MS),
    []
  );

  return [autoquoteTiersResponseState, fetchAutoquoteTiersDebounced] as const;
};

export default useRequestAutoquoteTiers;
